import { useEffect, useState, useMemo } from 'react';
import { Card, Space, Table, Input, Button, Descriptions, Col, Row, Flex, Form, Select, Drawer } from 'antd';
import OrderService from "services/order"
import { formatCurrency } from "utils/number"
import { formatDate } from "utils/date"
import { useNavigate, useParams } from 'react-router';
import { useApp } from 'contexts/app';
import ProductVariantService from "services/product_variant"
import CustomerService from "services/customer"

import { PlusSquareOutlined, EditOutlined } from "@ant-design/icons"
import InputNumber from "components/input-number"
import { toSearchText } from "utils/text"
import CustomerPicker from "../order/CustomerPicker"
import _ from "lodash"
import './table.css'

const service = new OrderService();
const { Search } = Input;
const OrderDetail = () => {
    const { showLoading, showNotify } = useApp();
    const [data, setData] = useState([]);
    const [customer, setCustomer] = useState({})
    const [lineItems, setLineItems] = useState([])
    const [form] = Form.useForm()
    //const customerPhone = Form.useWatch('username', form);
    const [open, setOpen] = useState(false);
    const [products, setProducts] = useState([]);
    const [filterProducts, setFilterProducts] = useState([]);
    const [showEditF, setShowEdit] = useState({});
    const [filter, setFilter] = useState({})
    const navigate = useNavigate();

    const showDrawer = () => {
        setOpen(true);
    };
    const onClose = () => {
        setOpen(false);
    };
    useEffect(() => {
        loadProducts()
    }, [])

    useEffect(() => {
      
        var info = filter.info;
        if (info) {
            info = toSearchText(info);
            var lst = products.filter(x => x.product.search_text?.includes(info));
            setFilterProducts([...lst])

        } else {
            setFilterProducts([...products])
        }

    }, [filter])


    const { id } = useParams();
    //const id = null;
    useEffect(() => {
        loadData();
        setShowEdit({})
    }, [id])


    const onCustomerChange = (cus) => {

        if (cus) {
            form.setFieldsValue({ shipping_address: { full_name: cus.full_name, address: cus.address } })
        }
    }



    const loadProducts = async () => {
        const service = new ProductVariantService();
        var lst = await service.list({});
        setProducts(lst);
        setFilterProducts(lst);
    }

    const loadData = async () => {
        if (id == null) {
            var newOrder = {
                line_items: [], shipping_address: {}, customer: {},
                discount_amount: 0, shipping_amount: 0,

                payment_status: { id: "unpaid" },
                shipping_status: { id: "not_shipped" },
                internal_status: { id: "pending" }

            };
            setData(newOrder);
            form.setFieldsValue({ ...newOrder })
            return;

        }
        showLoading(true);
        var order = await service.get({ id });
        setData(order);
        setCustomer(order.customer);
        setLineItems(order.line_items);
        form.setFieldsValue({ ...order })
        showLoading(false);
    }


    const setFilterValue = (name, value) => {

        var newFilter = { ...filter };
        newFilter[name] = value;
        setFilter(newFilter)
    }


    const onSearch = () => {

    }

    const onFinish = values => {
        saveOrder(values)
    };
    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };

    const addProduct = (id) => {
        var newLines = [...lineItems];
        var old = newLines.find(x => x.product_id == id);
        if (old) {
            old.quantity++;
        }
        else {
            var price = calculateProductPrice(id, 1);
            var product = getProductByID(id);
            var line = {
                product_id: id,
                quantity: 1,
                price: price,
                amount: price,
                product: product.product,
                variant: product,
                price_type: "1"
            }
            newLines.push(line)
        }
        setNewLinesItem(newLines);

    }

    const calculateProductPrice = (id, quantity) => {
        var product = products.find(x => x.id == id);
        if (!product)
            return 0;
        if (_.isArray(product.price_list)) {
            if (product.price_list.length > 0) {

                var price_list = _.orderBy(product.price_list, o => o.min * -1)
                var price = price_list.find(x => quantity >= x.min);
                if (price) {
                    return price.price;
                }

            }
        }
        return product.original_price ?? 0;
    }

    const getProductByID = (id) => {
        var product = products.find(x => x.id == id);
        return product;
    }

    const onLineQuantityChange = (id, quantity) => {
        var newLines = [...lineItems];
        var old = newLines.find(x => x.product_id == id);
        if (old) {
            old.quantity = quantity;
            if (old.quantity <= 0) {
                var index = newLines.findIndex(x => x.product_id == id);
                newLines.splice(index, 1);
            }
        }
        setNewLinesItem(newLines);
    }

    const onLinePriceChange = (id, price) => {
        var newLines = [...lineItems];
        var old = newLines.find(x => x.product_id == id);
        if (old) {
            old.price = price;

        }
        setNewLinesItem(newLines);
    }


    const setNewLinesItem = (newLines) => {
        newLines = calculateLineItems(newLines);
        setLineItems(newLines);
        var orederNew = calculateOrder(data, newLines);
        console.log(orederNew);
        setData(orederNew);

    }




    const setLineItemPriceType = (id, type) => {
        var newLines = [...lineItems];
        var old = newLines.find(x => x.product_id == id);
        if (old) {
            old.price_type = type;
        }
        newLines = calculateLineItems(newLines);
        setLineItems(newLines);
    }

    const calculateLineItems = (lines) => {
        for (let index = 0; index < lines.length; index++) {
            var line = lines[index];
            if (line.price_type == "1") {
                line.price = calculateProductPrice(line.product_id, line.quantity)
            }
            line.amount = line.price * line.quantity;

        }
        return lines;
    }

    const calculateOrder = (order, lines) => {
        var newOrder = { ...order };
        newOrder.sub_amount = _.sumBy(lines, x => x.amount);
        newOrder.total_item = _.sumBy(lineItems, x => x.quantity);
        newOrder.discount_amount = order.discount_amount ?? 0;
        newOrder.shipping_amount = order.shipping_amount ?? 0;
        newOrder.voucher_amount = order.voucher_amount ?? 0;
        newOrder.total_amount = newOrder.sub_amount - newOrder.discount_amount - newOrder.voucher_amount + newOrder.shipping_amount;
        return newOrder;
    }


    const saveOrder = async (info) => {
        showLoading(true)
        var newOrder = { ...info };
        var line = lineItems.map(x => {
            return ({
                product_id: x.product_id,
                quantity: x.quantity,
                price: x.price,
                amount: x.amount,
                price_type: x.price_type
            })
        })
        newOrder.line_items = line;
        newOrder.discount_amount = data.discount_amount ?? 0;
        newOrder.shipping_amount = data.shipping_amount ?? 0;
        newOrder.voucher_amount = data.voucher_amount ?? 0;
        newOrder.voucher_code = data.voucher_code;
        newOrder.loyalty_point = data.loyalty_point;
        newOrder.point_discount = data.point_discount;
        if (info.id) {
            newOrder = await service.update(newOrder);
            showNotify("Đã lưu đơn hàng");
            loadData();
        } else {
            newOrder = await service.create(newOrder);
            showNotify("Đã tạo mới đơn hàng")
            navigate(`/order/edit/${newOrder.id}`)
        }
        showLoading(false);




    }


    const onDiscountAmountChange = (number) => {
        var newOrder = { ...data };
        newOrder.discount_amount = number;

        newOrder.shipping_amount = newOrder.shipping_amount ?? 0;
        newOrder.voucher_amount = newOrder.voucher_amount ?? 0;
        newOrder.total_amount = newOrder.sub_amount - newOrder.discount_amount - newOrder.voucher_amount + newOrder.shipping_amount - newOrder.point_discount;

        setData(newOrder);
    }

    const onShippingAmountChange = (number) => {
        var newOrder = { ...data };
        newOrder.shipping_amount = number ?? 0;
        newOrder.voucher_amount = newOrder.voucher_amount ?? 0;
        newOrder.discount_amount = newOrder.discount_amount ?? 0;;
        newOrder.total_amount = newOrder.sub_amount - newOrder.discount_amount - newOrder.voucher_amount + newOrder.shipping_amount - newOrder.point_discount;
        setData(newOrder);
    }

    const onLoyaltyPointChange = (number) => {
        var newOrder = { ...data };
        newOrder.loyalty_point = number ?? 0;
        newOrder.point_discount = number ?? 0;
        newOrder.voucher_amount = newOrder.voucher_amount ?? 0;
        newOrder.discount_amount = newOrder.discount_amount ?? 0;;
        newOrder.total_amount = newOrder.sub_amount - newOrder.discount_amount - newOrder.voucher_amount + newOrder.shipping_amount - newOrder.point_discount;
        setData(newOrder);
    }




    const onVoucherCodeChange = e => {
        var newOrder = { ...data };
        newOrder.voucher_code = e.target.value
        setData(newOrder);
    }

    const showEdit = (name) => {
        var newShow = { ...showEditF };

        newShow[name] = !newShow[name];
        setShowEdit(newShow)
    }




    const productColumns = [
        {
            title: 'Sản phẩm',
            render: (record) => {
                return (
                    <>
                        {record.product.name}      {record.variant_title}
                    </>


                )
            }
        },

        {
            title: '',
            render: (record) => {
                return (
                    <>
                        <Button type='link' onClick={e => addProduct(record.id)}><PlusSquareOutlined />Thêm </Button>
                    </>


                )
            }
        },
    ];




    return (
        <Form
            name="basic"

            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            layout='vertical'

        >
            <Space direction="vertical" size={16} style={{ width: "100%" }}>



                <Card title="Thông tin chung" size='small' extra={<Button type='text'>Thu gọn</Button>}>
                    {/* <Card title="Thông tin chung" size='small' extra={<Button type='text'>Thu gọn</Button>}> */}

                    <div style={{ display: "block" }}>


                        <Form.Item
                            hidden
                            name={"id"}

                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="Số điện thoại"
                            name={["shipping_address", "phone_number"]}
                            rules={[{ required: true, message: 'Please input customer phone_number!' }]}
                        >
                            <CustomerPicker onCustomerChange={onCustomerChange} />
                        </Form.Item>

                        <Form.Item
                            label="Họ  và tên"
                            name={["shipping_address", "full_name"]}

                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="Địa chỉ"
                            name={["shipping_address", "address"]}

                        >
                            <Input />
                        </Form.Item>

                        <Row style={{ width: "100%" }} gutter={8}>
                            <Col span={8}>
                                <Form.Item
                                    label="Thanh toán"
                                    name={["payment_status", "id"]}

                                >

                                    <Select>
                                        <Select.Option value="unpaid">Chờ thanh toán</Select.Option>
                                        <Select.Option value="partial">Thanh toán 1 phần</Select.Option>
                                        <Select.Option value="paid">Đã thanh toán</Select.Option>
                                        <Select.Option value="waiting_verification">Chờ xác nhận thanh toán</Select.Option>

                                    </Select>
                                </Form.Item>

                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Vận chuyển"
                                    name={["shipping_status", "id"]}

                                >

                                    <Select>
                                        <Select.Option value="not_shipped">Chưa vận chuyển</Select.Option>
                                        <Select.Option value="shipping">Đang vận chuyển</Select.Option>
                                        <Select.Option value="shipped">Đã giao</Select.Option>
                                    </Select>


                                </Form.Item>

                            </Col>
                        </Row>
                        <Form.Item
                            label="Trạng thái nội bộ"
                            name={["internal_status", "id"]}

                        >

                            <Select>
                                <Select.Option value="pending">Chờ đóng gói</Select.Option>
                                <Select.Option value="packing">Đã đóng gói</Select.Option>
                            </Select>
                        </Form.Item>

                        <Form.Item
                            label="Ghi chú"
                            name={["internal", "note"]}

                        >

                            <Input />
                        </Form.Item>


                        <Form.Item
                            label="Mã vận đơn"
                            name={["shipping_status", "tracking_code"]}

                        >

                            <Input />
                        </Form.Item>

                    </div>
                </Card>


                <Row gutter={16}>
                    <Col span={16}>
                        <Card>
                            <table className='tbl_order' style={{ width: "100%" }}>
                                <tr>
                                    <th>
                                        <Space>
                                            Sản phẩm

                                        </Space>

                                    </th>
                                    <th>
                                        Số lượng
                                    </th>
                                    <th>
                                        Đơn giá
                                    </th>
                                    <th>
                                        Thành tiền
                                    </th>
                                </tr>

                                <tbody className='ant-table-tbody'>

                                    {lineItems.map(line => {
                                        return (

                                            <tr>
                                                <td>
                                                    {line.product.name} {line.variant.variant_title}
                                                </td>
                                                <td>
                                                    <InputNumber value={line.quantity} showCalculator={false} onChange={e => onLineQuantityChange(line.product_id, e)}></InputNumber>
                                                </td>
                                                <td style={{ textAlign: "right" }}>
                                                    {line.price_type == "2" ?
                                                        <>
                                                            <Space>
                                                                <InputNumber value={line.price} onChange={e => onLinePriceChange(line.product_id, e)} ></InputNumber>

                                                            </Space>

                                                        </>
                                                        :
                                                        <>

                                                            <Space>
                                                                {formatCurrency(line.price)}
                                                                <Button type='text' onClick={e => setLineItemPriceType(line.product_id, "2")}><EditOutlined /></Button>
                                                            </Space>
                                                        </>
                                                    }

                                                </td>
                                                <td style={{ textAlign: "right" }}>
                                                    {formatCurrency(line.amount)}
                                                </td>
                                            </tr>

                                        )
                                    })}
                                </tbody>
                            </table>

                            <Flex style={{ marginTop: 8 }} justify='flex-end'>
                                {!open &&
                                    <Button type="link" onClick={showDrawer} style={{ width: 150 }}>Thêm sản phẩm</Button>

                                }
                            </Flex>

                        </Card>


                        <Card title="Thêm sản phẩm" size='small' style={{ display: open ? "block" : "none", marginTop: 8 }} extra={<Button type='link' onClick={e => setOpen(false)}>Close</Button>}>
                            <Space direction='vertical' style={{ width: "100%" }}>

                                <Search onChange={e => setFilterValue("info", e.target.value)}>
                                </Search>
                                <Table columns={productColumns} dataSource={filterProducts} scroll={{ y: 400 }}>

                                </Table>
                            </Space>
                        </Card>
                    </Col>
                    <Col span={8} >
                        <Card>
                            <table style={{ width: "100%" }} className='tbl_order'>
                                <colgroup>
                                    <col></col>
                                    <col style={{ textAlign: "right" }}>
                                    </col>
                                </colgroup>
                                <tbody className='ant-table-tbody'>


                                    <tr>
                                        <td>
                                            Tiền hàng
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                            {formatCurrency(data.sub_amount)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Space>
                                                Giảm giá
                                                <Button onClick={e => showEdit("discount")} type='text'  ><EditOutlined /></Button>
                                            </Space>

                                        </td>
                                        <td style={{ textAlign: "right" }}>

                                            {!showEditF.discount ?
                                                <>
                                                    {formatCurrency(data.discount_amount)}
                                                </>
                                                :
                                                <Flex justify='flex-end'>

                                                    <InputNumber value={data.discount_amount} onChange={onDiscountAmountChange} showCalculator={false}></InputNumber>

                                                </Flex>
                                            }


                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <Space>
                                                Mã khuyến mãi
                                                <Button onClick={e => showEdit("voucher")} type='text'  ><EditOutlined /></Button>
                                            </Space>

                                        </td>
                                        <td style={{ textAlign: "right" }}>


                                            <Row>
                                                <Col span={12}>
                                                    {!showEditF.voucher ?
                                                        <>
                                                            {data.voucher_code}
                                                        </>
                                                        :
                                                        <Input value={data.voucher_code} onChange={onVoucherCodeChange}></Input>
                                                    }


                                                </Col>
                                                <Col span={12}>
                                                    <Flex justify='flex-end' align='center' style={{ height: "100%" }}>
                                                        {formatCurrency(data.voucher_amount)}
                                                    </Flex>
                                                </Col>
                                            </Row>

                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <Space>
                                                Xu
                                                <Button onClick={e => showEdit("point")} type='text'  ><EditOutlined /></Button>
                                            </Space>

                                        </td>
                                        <td style={{ textAlign: "right" }}>


                                            {!showEditF.point ?
                                                <>
                                                    {formatCurrency(data.loyalty_point)}
                                                </>
                                                :
                                                <Flex justify='flex-end'>

                                                    <InputNumber value={data.loyalty_point} onChange={onLoyaltyPointChange} showCalculator={false}></InputNumber>

                                                </Flex>
                                            }


                                        </td>
                                    </tr>



                                    <tr>
                                        <td>
                                            <Space>
                                                Phí ship
                                                <Button onClick={e => showEdit("shiping")} type='text'  ><EditOutlined /></Button>
                                            </Space>

                                        </td>
                                        <td style={{ textAlign: "right" }}>

                                            {!showEditF.shiping ?
                                                <>
                                                    {formatCurrency(data.shipping_amount)}
                                                </>
                                                :
                                                <Flex justify='flex-end'>

                                                    <InputNumber value={data.shipping_amount} onChange={onShippingAmountChange} showCalculator={false}></InputNumber>

                                                </Flex>
                                            }


                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            Tổng tiền
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                            {formatCurrency(data.total_amount)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <Flex justify='flex-end' style={{ marginTop: 16 }}>
                                <Space align='end' >
                                    {data.id &&
                                        <Button onClick={e => navigate(`/order/${data.id}`)}>Trở về</Button>
                                    }
                                    <Button type='primary' onClick={e => form.submit()}>Lưu</Button>
                                </Space>
                            </Flex>
                        </Card>
                    </Col>
                </Row>
            </Space>
            {/* <Drawer
                title="Sản phẩm"
                placement={"bottom"}
                closable={false}
                onClose={onClose}
                open={open}
                height={"75vh"}
                extra={<Button onClick={e => setOpen(false)}>Close</Button>}

            >

            </Drawer> */}

        </Form>
    )
}

export default OrderDetail;
